import dayjs, { Dayjs } from "dayjs";

export function timeToString(totalSeconds: number) {
	const years = Math.floor(totalSeconds / (3600 * 24 * 365));
	totalSeconds %= 3600 * 24 * 365;

	const months = Math.floor(totalSeconds / (3600 * 24 * 30));
	totalSeconds %= 3600 * 24 * 30;

	const days = Math.floor(totalSeconds / (3600 * 24));
	totalSeconds %= 3600 * 24;

	const hours = Math.floor(totalSeconds / 3600);
	totalSeconds %= 3600;

	const minutes = Math.floor(totalSeconds / 60);

	const seconds = totalSeconds % 60;

	const splittedFormattedSeconds = [
		`${years ? `${years} a` : ""}`,
		`${months ? `${months} m` : ""}`,
		`${days ? `${days} d` : ""}`,
		`${hours ? `${hours} h` : ""}`,
		`${minutes ? `${minutes} min` : ""}`,
		`${seconds ? `${seconds} s` : ""}`,
	].filter((a) => Boolean(a));
	const formattedSeconds = splittedFormattedSeconds.join(" ") || "0s";

	return formattedSeconds;
}

export function getAge(
	birthInput: string | Date | Dayjs,
	dateInput?: string | Date | Dayjs
): string {
	const birthdate = dayjs(birthInput);
	const date = dayjs(dateInput);

	let years = date.year() - birthdate.year();
	let months = date.month() - birthdate.month();
	let days = date.date() - birthdate.date();

	if (months < 0 || (months === 0 && days < 0)) {
		years--;
		months += 12;
	}

	if (days < 0) {
		const previousMonth = date.subtract(1, "month");
		days += previousMonth.daysInMonth();
		months--;
	}

	const periods = [
		years > 0 ? `${years} ${years > 1 ? "anos" : "ano"}` : "",
		months > 0 ? `${months} ${months > 1 ? "meses" : "mês"}` : "",
		days > 0 ? `${days} ${days > 1 ? "dias" : "dia"}` : "",
	].filter((p) => p !== "");

	if (periods.length === 1) return periods[0];
	if (periods.length === 2) return `${periods[0]} e ${periods[1]}`;
	if (periods.length === 3) return `${periods[0]}, ${periods[1]} e ${periods[2]}`;

	return "";
}

export function timeDimensionToDate(timeDimensionId: number) {
	const str = timeDimensionId.toString();
	const date = dayjs(str, "YYYYMMDD", true);

	return date.isValid() ? date : null;
}

export function timeDimensionToString(timeDimensionId: number, format: string = "DD/MM/YYYY") {
	const date = timeDimensionToDate(timeDimensionId);
	return date ? date.format(format) : "";
}

export function dateToTimeDimension(value: Dayjs | Date | string): number | null {
	const date = dayjs(value);
	if (!date.isValid()) return null;

	return parseInt(date.format("YYYYMMDD"), 10);
}
